import { useState } from "react";
import { CubeSide } from "./components/cube-side";
import { CubeProps, CubeSideName } from "./types";
import {
  COLLAPSED_CUBE_SIDE_NAMES,
  COLLAPSED_CUBE_SIDE_STYLES,
  CUBE_SIDE_NAMES,
} from "./constants";

const EMPTY_ARRAY: CubeSideName[] = [];

export function Cube({
  scale = 1,
  greyOutOtherSidesOnHover = false,
  values,
  selectedSides = EMPTY_ARRAY,
  onSideClick,
  onSideHover,
  sidesSaturation,
  mode = "expanded",
}: CubeProps) {
  const [hoveredSide, setHoveredSide] = useState<CubeSideName>();
  const hasActiveSide = !!hoveredSide || selectedSides?.length > 0;

  function handleSideMouseLeave() {
    if (greyOutOtherSidesOnHover) {
      setHoveredSide(undefined);
    }
    onSideHover?.(undefined);
  }

  function handleSideMouseEnter(side: CubeSideName) {
    if (greyOutOtherSidesOnHover) {
      setHoveredSide(side);
    }
    onSideHover?.(side);
  }

  function handleSideClick(side: CubeSideName) {
    onSideClick?.(side);
  }

  return (
    <svg
      width={273 * scale}
      height={297 * scale}
      viewBox="0 0 273 297"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="cube-sides">
        {(mode === "expanded"
          ? CUBE_SIDE_NAMES
          : COLLAPSED_CUBE_SIDE_NAMES
        ).map(side => {
          const fillColorSaturation = sidesSaturation?.[side];
          const isActive = selectedSides.includes(side) || hoveredSide === side;
          const isGreyedOut =
            !isActive && greyOutOtherSidesOnHover && hasActiveSide;

          return (
            <CubeSide
              key={side}
              side={side}
              scale={(values?.[side] ?? 0) / 100}
              fillColorSaturation={fillColorSaturation}
              isActive={isActive}
              isGreyedOut={isGreyedOut}
              onMouseEnter={handleSideMouseEnter}
              onMouseLeave={handleSideMouseLeave}
              onClick={handleSideClick}
              style={
                mode === "collapsed"
                  ? COLLAPSED_CUBE_SIDE_STYLES[side]
                  : undefined
              }
            />
          );
        })}
      </g>
    </svg>
  );
}
